import { gql } from '@apollo/client';

/**
 * Null when the brand never had team capability, which is how the backoffice
 * tells a solo brand from one whose members share a company set.
 */
export const GET_CB_TEAM = gql`
  query GetCbTeam($input: GetCbTeamInput!) {
    getCbTeam(input: $input) {
      id
      ownerId
      companyName
    }
  }
`;
